var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"ofertas-home"}},[_c('transition',{attrs:{"name":"animate-css","enter-active-class":"animated fadeIn","leave-active-class":"animated fadeOut","mode":"out-in"}},[_c('router-view')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }